/**
 * 账号与手机号绑定相关API
 */
export default function (request, { urltemplate, server }) {
  const prefix = `${server.API_SERVER}/access`

  return {
    /**
     * 通过旧的手机号获取短信验证码
     */
    getCodeByOldCellphone ({ body }) {
      return request({
        url: `${prefix}/accounts/actions/modify_mobile_number/verify_old_phone_number`,
        method: 'post',
        data: body
      })
    },

    /**
     * 验证旧的手机号收到的验证码
     */
    verifyOldCellphoneCode ({ body }) {
      return request({
        url: `${prefix}/accounts/actions/modify_mobile_number/verify_old_message_code`,
        method: 'post',
        data: body
      })
    },

    /**
     * 通过新的手机号获取短信验证码
     */
    getCodeByNewCellphone ({ body }) {
      return request({
        url: `${prefix}/accounts/actions/modify_mobile_number/send_new_phone_message`,
        method: 'post',
        data: body
      })
    },

    /**
     * 验证新的手机号收到的验证码
     */
    verifyNewCellphoneCode ({ body }) {
      return request({
        url: `${prefix}/accounts/actions/modify_mobile_number/verify_new_message_code`,
        method: 'post',
        data: body
      })
    }

  }
}
